import { Divider, Typography, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { preTheme } from "../../theme";

const useStyles = makeStyles((theme) => ({
  marginLeft: {
    marginLeft: "10px",
  },
  list: {
    listStyle: "square",
    "&::marker": {
      color: (props) => props.color || theme.palette.primary.main,
      [preTheme.breakpoints.up("lg")]: {
        fontSize: "22px",
      },
      [preTheme.breakpoints.up("xl")]: {
        fontSize: "28px",
      },
      [preTheme.breakpoints.up("xxl")]: {
        fontSize: "30px",
      },
      [preTheme.breakpoints.up("xxxl")]: {
        fontSize: "32px",
      },
    },
  },
  listSmall: {
    marginBottom: "0px",
  },
  listMedium: {
    marginBottom: ".6em",
    [preTheme.breakpoints.up("xl")]: {
      marginBottom: ".8em",
    },
    [preTheme.breakpoints.up("xxl")]: {
      marginBottom: "1em",
    },
  },
  blattList: {
    display: "flex",
    "&:before": {
      content: "url('../../assets/icons/blatt.svg')",
      aspectRatio: 1,
      width: "32px",
      [preTheme.breakpoints.up("lg")]: {
        width: "42px",
      },
      [preTheme.breakpoints.up("xxl")]: {
        width: "44px",
      },
      [preTheme.breakpoints.up("xxxl")]: {
        width: "48px",
      },
    },
  },
  noPadding: {
    paddingInlineStart: "15px",
  },
  fontSizeVerySmall: {
    fontSize: "14px",
    [preTheme.breakpoints.up("lg")]: {
      fontSize: "14px",
    },
    // 1200px
    [preTheme.breakpoints.up("xl")]: {
      fontSize: "14px",
    },
    // 1400px
    [preTheme.breakpoints.up("xxl")]: {
      fontSize: "16px",
    },
  },
  fontSizeSmall: {
    fontSize: "15px",
    [preTheme.breakpoints.up("lg")]: {
      fontSize: "16px",
    },
    // 1200px
    [preTheme.breakpoints.up("xl")]: {
      fontSize: "18px",
    },
    // 1400px
    [preTheme.breakpoints.up("xxl")]: {
      fontSize: "20px",
    },
  },
  fontSizeMedium: {
    fontSize: "20px",
    [preTheme.breakpoints.up("lg")]: {
      fontSize: "24px",
    },
    // 1200px
    [preTheme.breakpoints.up("xl")]: {
      fontSize: "26px",
    },
    // 1400px
    [preTheme.breakpoints.up("xxl")]: {
      fontSize: "28px",
    },
  },
  fontWeightRegular: {
    width: "fit-content",
    fontWeight: "400",
  },
  headlineVerySmall: {
    fontWeight: "700",
    [preTheme.breakpoints.up("lg")]: {
      fontSize: "14px",
    },
    [preTheme.breakpoints.up("xl")]: {
      fontSize: "14px",
    },
    [preTheme.breakpoints.up("xxl")]: {
      fontSize: "16px",
    },
    [preTheme.breakpoints.up("xxxl")]: {
      fontSize: "18px",
    },
  },
  headlineSmall: {
    fontWeight: "700",
    [preTheme.breakpoints.up("lg")]: {
      fontSize: "16px",
    },
    [preTheme.breakpoints.up("xl")]: {
      fontSize: "18px",
    },
    [preTheme.breakpoints.up("xxl")]: {
      fontSize: "20px",
    },
    [preTheme.breakpoints.up("xxxl")]: {
      fontSize: "22px",
    },
  },
  headlineMedium: {
    fontWeight: "700",
    [preTheme.breakpoints.up("lg")]: {
      fontSize: "22px",
    },
    [preTheme.breakpoints.up("xl")]: {
      fontSize: "28px",
    },
    [preTheme.breakpoints.up("xxl")]: {
      fontSize: "30px",
    },
    [preTheme.breakpoints.up("xxxl")]: {
      fontSize: "32px",
    },
  },
}));

export default function QList({
  items,
  divider,
  headline,
  listStyle,
  color,
  fontSize,
}) {
  const classes = useStyles({
    color,
  });

  function GenerateListItem(item, i) {
    if (Array.isArray(item)) {
      return <QList items={item} subItem={true} />;
    }
    return (
      <li
        className={clsx(
          listStyle === "blatt" ? classes.blattList : classes.list,
          fontSize === "small" || fontSize === "verysmall" ? classes.listSmall : classes.listMedium
        )}
      >
        <Typography
          variant="body1"
          className={clsx(
            fontSize === "small"
              ? classes.fontSizeSmall
              : fontSize === "verysmall"
              ? classes.fontSizeVerySmall
              : classes.fontSizeMedium,
            classes.fontWeightRegular,
            listStyle === "blatt" ? classes.marginLeft : null
          )}
        >
          {item}
        </Typography>
      </li>
    );
  }

  const listItems = items.map((item, i) => [
    GenerateListItem(item, i),
    divider && i !== items.length - 1 && <Divider key={`divider-${i}`} />,
  ]);

  return (
    <>
      {headline && (
        <Typography
          variant="body1"
          className={
            fontSize === "small"
              ? classes.headlineSmall
              : fontSize === "verysmall" ? classes.headlineVerySmall : classes.headlineMedium
          }
        >
          {headline}
        </Typography>
      )}
      <ul className={listStyle === "blatt" ? classes.noPadding : null}>
        {listItems}
      </ul>
    </>
  );
}
